import { defineStore } from 'pinia';
import { computed, ref, type Ref } from 'vue';
import { i18n } from '@/utils/i18n';
import { Users, LocalStorageKeys } from '@/utils/constants';

export const useAuthStore = defineStore('auth', () => {
  const status = ref('offline');
  const isConnected: Ref<boolean> = ref(false);
  const protocol: Ref<string> = ref(localStorage.getItem(LocalStorageKeys.Protocol) || 'https://');
  const serverIp: Ref<string> = ref(
    localStorage.getItem(LocalStorageKeys.ServerIP) || 'lab.infosupport.gr'
  );
  const port: Ref<string> = ref(localStorage.getItem(LocalStorageKeys.ServerPort) || '50056');

  const dbName: Ref<string> = ref(
    localStorage.getItem(LocalStorageKeys.DbName) || 'MobileWorldDelta'
  );
  const language: Ref<string> = ref(localStorage.getItem(LocalStorageKeys.Language) || '');
  const isSessionValid: Ref<boolean | null> = ref(null);
  const username = ref(localStorage.getItem(LocalStorageKeys.Username) || Users.Admin);
  const password = ref(localStorage.getItem(LocalStorageKeys.Password) || Users.AdminPassword);
  const locale = i18n.global.locale;
  const isAdmin = ref(false);

  const getBaseUrl = computed(() => {
    return `${protocol.value}/${serverIp.value}:${port.value}`;
  });

  async function logout(invalidSession: boolean = false) {
    if (invalidSession) isSessionValid.value = false;
    localStorage.removeItem(LocalStorageKeys.SessionDetails);
    localStorage.removeItem(LocalStorageKeys.SessionID);
    localStorage.removeItem(LocalStorageKeys.MwParams);
    localStorage.removeItem(LocalStorageKeys.InstallationModules);
    const storageRememberMe = localStorage.getItem(LocalStorageKeys.RememberMe) === 'true';
    if (!storageRememberMe) {
      localStorage.removeItem(LocalStorageKeys.Username);
      localStorage.removeItem(LocalStorageKeys.Password);
      localStorage.removeItem(LocalStorageKeys.DbName);
      localStorage.removeItem(LocalStorageKeys.ServerIP);
      localStorage.removeItem(LocalStorageKeys.ServerPort);
      localStorage.removeItem(LocalStorageKeys.Protocol);
    }
  }

  // Loading Overlay
  const activeRequests = ref(0);
  const isLoading = computed(() => activeRequests.value > 0);

  function addRequest() {
    activeRequests.value++;
  }
  function removeRequest() {
    activeRequests.value--;
    if (activeRequests.value < 0) {
      activeRequests.value = 0;
    }
  }
  function clearActiveRequestCounter() {
    activeRequests.value = 0;
  }

  return {
    isLoading,
    isConnected,
    isSessionValid,
    serverIp,
    port,
    dbName,
    language,
    username,
    getBaseUrl,
    password,
    status,
    locale,
    protocol,
    logout,
    isAdmin,
    addRequest,
    removeRequest,
    clearActiveRequestCounter,
  };
});
